export default __webpack_public_path__ + "static/Plots0055-f5734d63f5cfffd61e558b2501009de1.jpg";